import { Injectable } from '@angular/core';
import { ITenantConfig, TenantId } from '../../config/tenant.interface';
import { resolveTenantConfig } from '../../config/tenant-registry';

@Injectable({ providedIn: 'root' })
export class TenantService {
  private config!: ITenantConfig;

  /**
   * Called by APP_INITIALIZER before the app renders.
   * Resolves the active tenant from the browser host and stores it.
   */
  loadConfig(): ITenantConfig {
    this.config = resolveTenantConfig(window.location.host);
    return this.config;
  }

  getConfig(): ITenantConfig {
    return this.config;
  }

  getTenantId(): TenantId {
    return this.config.id;
  }

  isAbcl(): boolean {
    return this.config.id === 'ABCL';
  }

  isDoqfy(): boolean {
    return this.config.id === 'DOQFY';
  }

  isCyberArkEnabled(): boolean {
    return this.config.auth.type === 'cyberark';
  }
}
